// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore, collection, addDoc } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyAs9xrrHMRLvQ-mWLRaPE5i-dDYUD8jnY8",
  authDomain: "nymfodora.firebaseapp.com",
  projectId: "nymfodora",
  storageBucket: "nymfodora.firebasestorage.app",
  messagingSenderId: "991855357387",
  appId: "1:991855357387:web:f08030688480823efe1a4e",
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export { db, collection, addDoc };
